/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInUri: core.serialization.ObjectSchema<serializers.NotInUri.Raw, Truvity.NotInUri> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.string()),
    });

export declare namespace NotInUri {
    export interface Raw {
        values: string[];
    }
}
